/** Query-aware matching keeps Incoming and Outgoing distinct in the sidebar. */
export function isTravelNavigationActive(pathname: string, search: string, href: string) {
  const target = new URL(href, 'https://navigation.local');
  if (target.pathname === '/travel') return pathname === '/travel';
  if (target.pathname === '/travel/cari')
    return pathname === '/travel/cari' || pathname.startsWith('/travel/customers') || pathname.startsWith('/travel/partners')
      || (pathname.startsWith('/travel/cari/') && !['types','balances','transactions','mizan'].some(p => pathname.startsWith('/travel/cari/' + p)));
  if (pathname !== target.pathname && !pathname.startsWith(target.pathname + '/')) return false;
  const current = new URLSearchParams(search);
  for (const key of ['direction', 'tourType', 'tab']) {
    if ((target.searchParams.get(key) ?? '') !== (current.get(key) ?? '') &&
        (target.searchParams.has(key) || ['direction', 'tourType'].includes(key))) return false;
  }
  if (target.pathname === '/travel/accounting') return pathname === target.pathname;
  return true;
}
